import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "lesson-interaction"
};
import { reactive, ref, toRefs, onMounted, watch, onUnmounted } from 'vue';
import SynthesisList from '@/views/stuSpaceInfo/SynthesisList';
import detailDialog from './detailDialog';
import { getClassShow } from '@/api/spaceInfo.js';
import bus from '@/util/bus.js';
export default {
  __name: 'index',
  props: {
    visitorType: {
      // 个人视角(我自己)0，游客视角1(自己访问自己空间仍为个人视角)
      type: Number,
      default: 0
    },
    isOpenView: {
      // 个人视角(公开)
      type: Boolean,
      default: false
    },
    curUserId: {
      //当前用户id
      type: String
    },
    useToHome: {
      // 用于首页
      type: Boolean,
      default: false
    },
    showScope: {
      type: String
      // default: '0'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _toRefs = toRefs(props),
      useToHome = _toRefs.useToHome,
      showScope = _toRefs.showScope,
      curUserId = _toRefs.curUserId;
    var list = ref([]); //课堂互动列表

    var page = reactive({
      //分页
      size: 9,
      current: 1
    });
    var totalCount = ref(0);
    var isFinish = ref(false); //是否加载完毕
    var loading = ref('');
    var showDetail = ref(false);
    var detailQuery = ref(null); //展示详情参数

    var loadData = function loadData() {
      // page.size = useToHome.value ? 9 : 6 // 该组件用于首页，差异处理
      getClassShow(curUserId.value, showScope.value, page).then(function (res) {
        var _list$value;
        var _res$data$data = res.data.data,
          records = _res$data$data.records,
          total = _res$data$data.total;
        totalCount.value = total;
        (_list$value = list.value).push.apply(_list$value, _toConsumableArray(records ? records : []));
        isFinish.value = page.current * page.size >= total;
        loading.value = '';
      });
    };
    var onLoad = function onLoad(val) {
      if (isFinish.value || loading.value) {
        return;
      }
      // console.log(val, '---val',isFinish.value, '---  isFinish.value' )
      if (val) page.current++;
      loading.value = 'loading';
      loadData();
    };
    var onScroll = function onScroll(scrollBottom) {
      console.log('scrollBottom', scrollBottom);
    };
    // 查看详情
    var lookDetail = function lookDetail(item) {
      showDetail.value = true;
      detailQuery.value = {
        userId: curUserId.value,
        lessonId: item.lessonId
      };
    };
    // 刷新数据
    var refresh = function refresh() {
      page.current = 1;
      list.value = [];
      isFinish.value = false;
      onLoad();
    };
    watch(function () {
      return showScope.value;
    }, function (val) {
      if (val) {
        refresh();
      }
    }, {
      immediate: true
    });
    onMounted(function () {
      // onLoad()
      bus.on('scrollLoad', function (val) {
        // console.log(val, '---scrollLoad')
        if (useToHome.value) return; // 该组件用于首页，差异处理
        if (val) {
          onLoad(val);
        }
      });
    });
    onUnmounted(function () {
      bus.off('scrollLoad');
    });
    return function (_ctx, _cache) {
      var _component_t_list = _resolveComponent("t-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_list, {
        "async-loading": loading.value,
        onScroll: onScroll,
        class: _normalizeClass({
          empty: !list.value.length && !Boolean(loading.value) && !_unref(useToHome)
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(SynthesisList), {
            isWhere: "lesson",
            synthesis: list.value,
            visitorType: __props.visitorType,
            "is-open-view": __props.isOpenView,
            loading: loading.value,
            onUpload: refresh,
            onDetail: lookDetail
          }, null, 8, ["synthesis", "visitorType", "is-open-view", "loading"])];
        }),
        _: 1
      }, 8, ["async-loading", "class"]), showDetail.value ? (_openBlock(), _createBlock(_unref(detailDialog), {
        key: 0,
        visible: showDetail.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return showDetail.value = $event;
        }),
        data: detailQuery.value,
        onUpload: refresh
      }, null, 8, ["visible", "data"])) : _createCommentVNode("", true)]);
    };
  }
};